module.exports = __webpack_public_path__ + "img/flagship.c4492d6.png";